import { useSelector } from 'react-redux';
import { getCurrentCurrencyCultureInfo } from '@mews-commander/core/legacy-globalization';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const CurrencyFormatHint = () => {
    const { groupSeparator, decimalSeparator } = useSelector(getCurrentCurrencyCultureInfo);
    return (
        <LocalizedText
            textKey={TextKey.NumberFormatHint}
            substitutes={{
                groupSeparator,
                decimalSeparator,
            }}
        />
    );
};
